"use client";

import { c as _c } from "react/compiler-runtime";
import { GET_SHORTLISTED_PROJECTS_QUERY } from "@/gql/project";
import { useBuyerPropertiesStore } from "@/stores/buyer/buyer-properties-store";
import { BuyerProject } from "@/types/buyerProject";
import { useQuery } from "@apollo/client";
import { useEffect } from "react";
import { useRelationship } from "./use-relationship";

/**
 * Custom hook to fetch and manage shortlisted properties (both units and projects).
 * This hook wraps the query logic and store updates for shortlisted projects,
 * while buyer units are handled through the BUYER_DASHBOARD_QUERY.
 *
 * @param buyerGroupId - The buyer group ID for fetching shortlisted properties
 * @returns Query data and loading/error states
 */
export function useShortlistedProperties(buyerGroupId) {
  const $ = _c(14);
  const {
    user,
    isSeller,
    isAuthenticated
  } = useRelationship();
  const {
    setShortlistedProjects
  } = useBuyerPropertiesStore();
  const t0 = buyerGroupId || "";
  const t1 = user?.id || "";
  let t2;
  if ($[0] !== t0 || $[1] !== t1) {
    t2 = {
      filters: {
        getShortlistedProjects: {
          buyerId: t0,
          userId: t1
        }
      }
    };
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = !isAuthenticated || !buyerGroupId || !user?.id || isSeller;
  let t4;
  if ($[3] !== t2 || $[4] !== t3) {
    t4 = {
      variables: t2,
      skip: t3,
      fetchPolicy: "network-only",
      nextFetchPolicy: "cache-first",
      notifyOnNetworkStatusChange: true,
      errorPolicy: "all"
    };
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const {
    data: shortlistedProjectsData,
    loading,
    error
  } = useQuery(GET_SHORTLISTED_PROJECTS_QUERY, t4);
  let t5;
  let t6;
  if ($[6] !== setShortlistedProjects || $[7] !== shortlistedProjectsData) {
    t5 = () => {
      if (shortlistedProjectsData?.projects?.getShortlistedProjects) {
        const projects = shortlistedProjectsData.projects.getShortlistedProjects.map(_temp) as BuyerProject[];
        setShortlistedProjects(projects);
      }
    };
    t6 = [shortlistedProjectsData, setShortlistedProjects];
    $[6] = setShortlistedProjects;
    $[7] = shortlistedProjectsData;
    $[8] = t5;
    $[9] = t6;
  } else {
    t5 = $[8];
    t6 = $[9];
  }
  useEffect(t5, t6);
  let t7;
  if ($[10] !== error || $[11] !== loading || $[12] !== shortlistedProjectsData) {
    t7 = {
      shortlistedProjectsData,
      loading,
      error
    };
    $[10] = error;
    $[11] = loading;
    $[12] = shortlistedProjectsData;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
}
function _temp(p) {
  return {
    id: p.id,
    project: {
      id: p.id,
      name: p.name
    },
    processDetails: [{
      process: "shortlisting",
      stage: "done",
      status: "active"
    }]
  };
}